// see https://github.com/microsoft/TypeScript/issues/29729
type LiteralUnion<T extends U, U = string> = T | (U & Record<never, never>);

type XmlType = LiteralUnion<"string" | "boolean" | "enumeration" | "date" | "integer" | "decimal" | "time">;
type A12Type = LiteralUnion<
	| "StringType"
	| "BooleanType"
	| "ConfirmType"
	| "EnumerationType"
	| "DateType"
	| "NumberType"
	| "TimeType"
	| "AttachmentType"
>;
interface A12TypeMapEntry {
	readonly primaryTypes: readonly A12Type[];
	readonly alternativeTypes?: readonly A12Type[];
}

export const A12TypeMap: Record<A12Type, A12TypeMapEntry> = {
	StringType: {
		primaryTypes: ["StringType"],
		alternativeTypes: ["EnumerationType"]
	},
	BooleanType: {
		primaryTypes: ["BooleanType", "ConfirmType"],
		alternativeTypes: ["StringType"]
	},
	ConfirmType: {
		primaryTypes: ["BooleanType", "ConfirmType"],
		alternativeTypes: ["StringType"]
	},
	EnumerationType: {
		primaryTypes: ["EnumerationType"],
		alternativeTypes: ["StringType"]
	},
	DateType: {
		primaryTypes: ["DateType"],
		alternativeTypes: ["StringType"]
	},
	NumberType: {
		primaryTypes: ["NumberType"],
		alternativeTypes: ["StringType"]
	},
	TimeType: {
		primaryTypes: ["TimeType"],
		alternativeTypes: ["StringType"]
	},
	DateTimeType: {
		primaryTypes: ["DateTimeType"],
		alternativeTypes: ["StringType"]
	},
	AttachmentType: {
		primaryTypes: ["AttachmentType"]
	}
} as const;

export const XmlToA12TypeMap: Record<XmlType, A12Type> = {
	string: "StringType",
	boolean: "BooleanType",
	enumeration: "EnumerationType",
	date: "DateType",
	integer: "NumberType",
	decimal: "NumberType",
	time: "TimeType",
	dateTime: "DateTimeType"
} as const;
